import { Box, Button, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { HiPencil } from 'react-icons/hi2';
import { useNavigate } from 'react-router-dom';
import AccountDetailsForm from '../components/AccountDetailsForm';

export default function AccountDetails() {
    const navigate = useNavigate();

    return (
        <VStack spacing={6} align='stretch' w='full'>
            <Flex w='full' justify='space-between' alignItems='center'>
                <Box>
                    <Heading size='lg' color='gray.800' mb={2}>
                        Account Details
                    </Heading>
                    <Text color='gray.600' fontSize='md'>
                        Manage your account details
                    </Text>
                </Box>
                <Button size='lg' leftIcon={<HiPencil />} variant='solid' colorScheme='primary' fontSize='sm' fontWeight={600} onClick={() => navigate('edit-child')}>
                    Add Your Child
                </Button>
            </Flex>

            <AccountDetailsForm />
        </VStack>
    );
}
